module.exports = __webpack_public_path__ + "static/img/jigou-henansheng-top.858c206.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-henansheng-top.png
// module id = Mv8c
// module chunks = 2